// @flow

import isEmpty from 'lodash.isempty';
import {hasId} from './hasId';

import type {TreeStructure, ExpandedTree} from '../typedef';

export const parseExpandedIds = (data: TreeStructure, idsToExpand: Array<string>): ExpandedTree =>
    data.reduce((acc, item) => {
        const expanded = hasId(item, idsToExpand);

        if (expanded) {
            if (item.children) {
                const children = parseExpandedIds(item.children, idsToExpand);
                if (!isEmpty(children)) {
                    return {...acc, [item.id]: {expanded, children}};
                }
            }
            return {...acc, [item.id]: {expanded}};
        }

        return acc;
    }, {});
